import { TextField, TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';
import styled from 'styled-components';

const StyledTextField = styled(TextField)`
  width: 230px;
`;

const WizardTextField = forwardRef<any, TextFieldProps>((props: TextFieldProps, ref) => {
  return <StyledTextField {...props} variant="outlined" ref={ref} size={props.size || 'small'} />;
});

export default WizardTextField;
